export const iconFontAwesomePunctuationSymbolsQuoteLeft = (
	<i className="fa-solid fa-quote-left"></i>
);
